import { render } from "./DatabaseConfigScreen.vue?vue&type=template&id=40379d4c&scoped=true"
import script from "./DatabaseConfigScreen.vue?vue&type=script&lang=js"
export * from "./DatabaseConfigScreen.vue?vue&type=script&lang=js"

import "./installer-page.scss?vue&type=style&index=0&id=40379d4c&lang=scss&scoped=true"
import "./DatabaseConfigScreen.vue?vue&type=style&index=1&id=40379d4c&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/orangehrm/orangehrm/installer/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-40379d4c"]])

export default __exports__